import React from "react";

// ── Badge ─────────────────────────────────────────────────────────────────────
export function Badge({ label, color }) {
  return (
    <span
      className="ua-badge ua-badge-info"
      style={{ background: color + "18", color, borderColor: color + "33" }}
    >
      {label}
    </span>
  );
}

// ── Section Head ──────────────────────────────────────────────────────────────
export function SectionHead({ title, sub, action, onAction }) {
  return (
    <div className="ua-card-head">
      <div>
        <span className="ua-card-title">{title}</span>
        {sub && <span className="ua-card-sub">{sub}</span>}
      </div>
      {action && (
        <button
          onClick={onAction}
          style={{ fontSize: 12, color: "var(--b)", background: "none", border: "none", cursor: "pointer", padding: 0, fontFamily:"var(--fb)" }}
        >
          {action}
        </button>
      )}
    </div>
  );
}

// ── Tab Nav ───────────────────────────────────────────────────────────────────
export function TabNav({ tabs, active, onChange }) {
  return (
    <div className="ua-tab-nav">
      {tabs.map((t) => (
        <button
          key={t}
          onClick={() => onChange(t)}
          className={`ua-tab-btn${active === t ? " active" : ""}`}
        >
          {t}
        </button>
      ))}
    </div>
  );
}